<template>
  <AdminModal
    :is-open="isOpen"
    modalSize="md"
    :modal-title="`${lessonAccess.name} 학생 정보 수정`"
    :confirm="update"
    :close="close"
    confirmButtonTitle="수정"
    :loading="loading"
    name="editLessonAccessModal"
  >
    <b-container>
      <b-row class="my-2">
        <b-col>
          <b-form-floating-label>
            이름
          </b-form-floating-label>
          <b-form-input
            id="input-1"
            v-model="name"
            type="text"
            required
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-floating-label>전화번호</b-form-floating-label>
          <b-form-input
            id="input-1"
            v-model.trim="phoneNumber"
            type="text"
            required
            @keyup="formatPhoneNumber(phoneNumber)"
          />
        </b-col>
      </b-row>
    </b-container>
  </AdminModal>
</template>

<script>
import api from "@/api/api"
import AdminModal from "@/components/modals/AdminModal.vue";

export default {
  name: "EditLessonAccessModal",
  components: {AdminModal},
  props: ['isOpen', 'reload', 'close', 'lessonAccess'],
  data() {
    return {
      loading: false,
      name: "",
      phoneNumber: "",
    }
  },
  mounted() {
    this.name = this.lessonAccess.name
    this.phoneNumber = this.lessonAccess.phoneNumber
  },
  methods: {
    formatPhoneNumber(phoneNumber) {
      if (phoneNumber.length === 0 || phoneNumber.length <= 3) {
        this.phoneNumber = phoneNumber
      } else {
        let input = phoneNumber;
        // 숫자만 남기고 모두 제거
        input = input.replace(/[^0-9]/g, "");

        let result = [];
        let restNumber = input;

        if (restNumber.length > 3) {
          result.push(restNumber.substr(0, 3));
          restNumber = restNumber.substring(3);
        }

        if (restNumber.length > 4) {
          result.push(restNumber.substr(0, 4));
          restNumber = restNumber.substring(4);
        }

        if (restNumber.length > 0) {
          result.push(restNumber);
        }

        this.phoneNumber = result.join("-");
      }
    },
    update() {
      if (this.name.length === 0) {
        this.$toast.show('이름을 입력하세요.',
          {
            position: "top-right",
            duration: 2000
          });
        return
      }

      if (this.phoneNumber.length === 0) {
        this.$toast.show('전화번호를 입력하세요.',
          {
            position: "top-right",
            duration: 2000
          });
        return
      }

      const regPhone = /^([0-9]{3})-?([0-9]{3,4})-?([0-9]{4})$/;
      if (!regPhone.test(this.phoneNumber) || this.phoneNumber.length === 0 || this.phoneNumber.length > 13) {
        this.$toast.error('올바른 전화번호를 입력해주세요.',
          {
            position: "top-right",
            duration: 2000
          })
        return
      }


      this.loading = true
      api.lessonAccesses.updateLessonAccess(
        {
          id: this.lessonAccess.id,
          name: this.name,
          phoneNumber: this.phoneNumber
        },
        (response) => {
          this.reload()
          this.$toast.success('수정 완료',
            {
              position: "top-right",
              duration: 2000
            })
          this.close()
        }, (e) => {
          this.loading = false
          this.$toast.error(  `등록 실패 `,
            {
              position: "top-right",
              duration: 2000,
            });
        })
    }
  }
}
</script>

<style scoped>

</style>